import Users from '@/components/users/Users'
import UsersNew from '@/components/users/UsersNew'
import UsersEdit from '@/components/users/UsersEdit'
export default [
  {
    path: '/users',
    name: 'users',
    component: Users,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/usersNew',
    name: 'usersNew',
    component: UsersNew,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/usersEdit/:id/edit',
    name: 'usersEdit',
    component: UsersEdit,
    meta: {
      requiresAuth: true
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/usersRoutes.js